const API_KEY = 'AIzaSyDq8v6uLjoXMgbutWSRIQuXEKfqOdaxHB8';
export default API_KEY;